import { COMMON_TEXT } from '@/helpers/common-text';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from 'src/components/CustomComponent/LoadingSpinner';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { convertValueToValues } from '@/helpers/utility';
import { createAuthenticatedApiClient } from 'src/helpers/api-client';
import { WorkflowsApi } from '@/openapi/apis/WorkflowsApi';
import Toaster from 'src/components/CustomComponent/Toaster';

@connect(state => ({
  tenantId: state.querystring?.['select-tenant']?.[0],
  querystring: state.querystring,
  sessionStore: state.session,
}))
class SignageComponentNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notice: '',
      errorNotice: '',
      isUpdating: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);

    const { notice, isLoading } = this.props;
    this.setState({
      notice,
      isLoading,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const input = document.querySelector('#notice-input-id');
    if (input) {
      this.checkInput(input);
    }
  };

  componentDidUpdate(prevProps) {
    const { notice, isLoading } = this.props;
    const { notice: prevNotice, isLoading: prevIsLoading } = prevProps;

    const isDataChanged = notice !== prevNotice;
    const isLoadingChanged = isLoading !== prevIsLoading;

    if (isDataChanged || isLoadingChanged) {
      this.setState({
        notice,
        isLoading,
      });
    }
  }

  onChange = value => {
    const escapedValue = value.replace(/\n/g, '\\n');
    this.setState({ notice: escapedValue }, () => {
      const input = document.querySelector('#notice-input-id');
      if (input) {
        this.checkInput(input);
      }
    });
  };

  updateButtonOnClicked = () => {
    const { notice } = this.state;
    const escapedValue = notice.replace(/\n/g, '\\n');

    const updatePayload = {
      value: {
        notice: escapedValue,
      },
    };
    if (updatePayload.value) {
      this.updateData({ updatePayLoad: updatePayload });
    }
  };

  updateData = async ({ updatePayLoad }) => {
    this.setState({ isUpdating: true });
    // eslint-disable-next-line
    const { isSuccess } = await this.updateSetComponents({ updatePayLoad });

    if (isSuccess) {
      this.setState({ isUpdating: false }, () => {
        Toaster.success(COMMON_TEXT.SAVED_SUCCESSFULLY);
        this.props.updateNotice({ isUpdate: true });
      });
    } else {
      this.setState({ isUpdating: false }, () => {
        Toaster.error(COMMON_TEXT.SAVE_FAILED);
      });
    }
  };

  updateSetComponents = async ({ updatePayLoad }) => {
    try {
      const workflowsApi = createAuthenticatedApiClient(WorkflowsApi);
      const convertedPayload = {
        ...convertValueToValues(updatePayLoad),
        tenantId: this.props.tenantId,
      };
      const updateRes = await workflowsApi.updateSettingsSignageNotices({
        apiPostWorkflowRequest: convertedPayload
      });

      const { success } = updateRes;
      if (!success) {
        throw Error('update signage notice error');
      }
      return { isSuccess: true };
    } catch (error) {
      console.error('update signage notice error', error);
    }
    return { isSuccess: false };
  };

  calculateLines(content, inputWidth, context) {
    let currentLineWidth = 0;
    let lines = 1;

    for (let i = 0; i < content.length; i++) {
      const charWidth = context.measureText(content[i]).width;
      if (currentLineWidth + charWidth > inputWidth) {
        lines++;
        currentLineWidth = charWidth;
      } else {
        currentLineWidth += charWidth;
      }
    }

    return lines;
  }

  checkInput(inputElement) {
    const inputWidth = inputElement.offsetWidth - 28; // 28px is the number of left and right padding: 24px, left and right margin: 4px
    const maxLines = 3;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = getComputedStyle(inputElement).font;

    const content = inputElement.value;

    const lines = this.calculateLines(content, inputWidth, context);

    const lineBreaks = (content.match(/\n/g) || []).length;

    const totalLines = lines + lineBreaks;

    if (totalLines > maxLines) {
      this.setState({ errorNotice: COMMON_TEXT.INPUT_NOTICE_ERROR_MESSAGE });
    } else {
      this.setState({ errorNotice: '' });
    }
  }

  render() {
    const { notice, isUpdating, errorNotice } = this.state;
    const { isLoading } = this.props;

    const canSubmit = errorNotice.length > 0;
    const noticeStr = notice.replace(/\\n/g, '\n');

    return (
      <>
        <div className="signage-components-notice-container main-container">
          {isLoading || isUpdating ? (
            <LoadingSpinner />
          ) : (
            <div className='main-container-inner'>
              <div className='input-section'>
                <div className="input-container">
                  <InputTextarea
                    id="notice-input-id"
                    autoResize
                    value={noticeStr}
                    rows={4}
                    onChange={e => this.onChange(e.target.value)}
                  />
                </div>
                {errorNotice && (
                  <div className="validation-error-message">
                    {errorNotice}
                  </div>
                )}
              </div>
              
              <div className="button-container is-submit-button-container">
                <Button
                  className="figma-save-button"
                  loading={isUpdating}
                  disabled={canSubmit}
                  onClick={this.updateButtonOnClicked}
                >
                  <span className="figma-save-icon">
                    <img src="assets/img/save-setting-icon.svg" alt="Save" />
                  </span>
                  <span className="figma-save-label">保存</span>
                </Button>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

SignageComponentNotice.propTypes = {
  updateNotice: PropTypes.func,
};
export default SignageComponentNotice;
